import { IGalleryConfig } from '@bridebook/web/app-basic/components/supplier/sections/gallery/gallery';
import { FelaCSS, colors } from '@bridebook/ui';

interface IStyle {
  wrapper: FelaCSS;
  header: FelaCSS;
  desc: FelaCSS;
  button: FelaCSS;
}

const styles = (size?: IGalleryConfig['ctaSize']): IStyle => ({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))',
  },
  header: {
    fontDefaultSemiBold: 26,
    color: colors.white,
    ...(size === 'small' && {
      fontDefaultSemiBold: 20,
    }),
  },
  desc: {
    color: colors.white,
    marginBottom: 5,
  },
  button: {
    paddingHorizontal: 4,
  },
});

export default styles;
